import type { PlatformFeatureType } from "@/types/graphql/site.generated";

export function platformHasFeature(
  platform:
    | { features?: readonly PlatformFeatureType[] | null }
    | null
    | undefined,
  feature: PlatformFeatureType,
): boolean {
  return Boolean(platform?.features?.includes(feature));
}
